import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import About from "../components/landing/About";
import Programs from "../components/landing/Programs";
import Placements from "../components/landing/Placements";
import WhyChoose from "../components/landing/WhyChoose";
import CampusLife from "../components/landing/CampusLife";
import VideoTour from "../components/landing/VideoTour";
import AdmissionProcess from "../components/landing/AdmissionProcess";
import Testimonials from "../components/landing/Testimonials";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";
import Extras from "../components/landing/Extras";
import { Toaster } from "../components/ui/sonner";

const Landing = () => {
  return (
    <div className="min-h-screen bg-megha-bg" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Programs />
        <Placements />
        <WhyChoose />
        <CampusLife />
        <VideoTour />
        <AdmissionProcess />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <Extras />
      <Toaster position="top-center" richColors closeButton />
      {/* Bottom padding for mobile sticky CTA */}
      <div className="h-20 lg:hidden" aria-hidden />
    </div>
  );
};

export default Landing;
